import {ThemeDeviceNames} from '../../types/ThemeDevices';

export const Devices: ThemeDeviceNames = {
  mobile: {max: 480},
  tablet: {min: 481, max: 768},
  desktop: {min: 769},
};
